import React from "react";
import ComplianceTemplateEditor from "@/components/ComplianceTemplateEditor";

export default function ComplianceSetup() {
  return (
    <div data-testid="compliance-setup-page">
      <div className="text-[11px] uppercase tracking-wider text-slate-500">Compliance</div>
      <h1 className="text-3xl md:text-4xl font-semibold tracking-tight">Calendar setup</h1>
      <p className="text-sm text-slate-500 mt-1">Statutory filings, due dates, groups and fee presets used when you add a compliance calendar for a client.</p>
      <ComplianceTemplateEditor />
    </div>
  );
}
